// This intermediate build file generated by Tailwind CLI, will be
// merged by Vite into the main project when it detects a change
import './css/tailwind-temp.css'
import './css/w2.css'
import './css/fontello-header-icons.css'
import './css/fonts.css'

// TODO: Consider a way to import only a subset of fontawesome that we actually use
import '@fortawesome/fontawesome-free/css/all.css'

// TODO: Convert modal dialogs to the apps-modal style ones (register and childrenincare)

import Validator from '@jdlien/validator'
window.Validator = Validator

import { parseDate, formatDateTime, momentToFPFormat } from '@jdlien/validator-utils'
window.parseDate = parseDate
window.formatDateTime = formatDateTime
window.momentToFPFormat = momentToFPFormat

import flatpickr from 'flatpickr'
window.flatpickr = flatpickr
